<template>
  <div class="play">
    <div style="height: 64px; background-color: #000; position: absolute; top: 0; width: 100%"></div>
    <div class="main">
      <div class="topCon content">
        <div class="subject">
          <div class="subject_left">
            <div class="player" id="youkuplayer">
              <video
                v-if="vidSrc"
                ref="videoPlayer"
                :src="vidSrc"
                controls
                autoplay
                style="width: 100%; height: 100%; background: #000"
              ></video>
            </div>
          </div>
          <div class="subject_right">
            <div class="title">{{ videoObj.title }}</div>
            <div class="notice">{{ videoObj.description }}</div>
            <div class="but">
              <div @click="collectClick">
                <img src="/img/collect.png" alt="" />
                <span>收藏</span>
              </div>
              <div></div>
              <div @click="shareVisible = !shareVisible">
                <img src="/img/newPages/fenxiang.png" alt="" />
                <span>分享</span>
              </div>
            </div>
            <div
              v-show="shareVisible"
              class="social-share"
              data-sites="qzone,qq,weibo,wechat,douban"
            ></div>
            <div class="collection" v-if="dramasObj.episode > 1">剧集</div>
            <div class="collectionNum" v-if="dramasObj.episode > 1 && dramasObj.episode <= 30">
              <div
                v-for="(ep, index) in dramasObj.episodeList"
                :key="index"
                :class="{ select: dramasObj.nowEpisode === index + 1 }"
                @click="episodeClick(index + 1)"
              >{{ index + 1 }}</div>
            </div>
            <div class="grid" v-if="dramasObj.episode > 30">
              <li
                v-for="(ep, index) in dramasObj.episodeList"
                :key="index"
                :class="{ select: dramasObj.nowEpisode === index + 1 }"
                @click="episodeClick(index + 1)"
              >{{ index + 1 }}</li>
            </div>
          </div>
        </div>
        <div class="details">
          <div class="title">
            <span>{{ videoObj.title }}{{ dramasObj.episode > 1 ? ' 第' + dramasObj.nowEpisode + '集' : '' }}</span>
            <span>{{ videoObj.viewCounts || 0 }}</span>
          </div>
          <div class="brief">
            <span>简介</span>
          </div>
          <div class="cont">
            <span>{{ videoObj.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="recommend" v-if="seniorityInfo.list.length > 0">
      <div class="title">热门推荐</div>
      <ul class="main_list">
        <li v-for="item in seniorityInfo.list" :key="item.id" @click="goDetail(item)">
          <img :src="item.src" alt="" />
          <span class="name">{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div class="advertisement" v-if="bottomBanner">
      <a :href="bottomBanner.link" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div>
  </div>
</template>

<script>
import { getToken, getUser } from '@/utils/auth'

export default {
  name: 'TVplayPage',
  data() {
    return {
      params: {
        id: this.$route.query.id || this.$route.query.contentId || 40
      },
      videoObj: {
        id: null,
        title: '',
        description: '',
        videoImg: '',
        viewCounts: 0,
        chargeType: null,
        permission: false
      },
      dramasObj: {
        episode: 1,
        nowEpisode: 1,
        disableDramas: true,
        episodeList: []
      },
      videoFiles: [],
      vidSrc: null,
      seniorityInfo: {
        title: '热门推荐',
        type: 'image',
        list: []
      },
      bottomBanner: null,
      mediaInfo: null,
      loginStatus: false,
      shareVisible: false
    }
  },
  mounted() {
    this.getData()
    this.getFooterData()
    this.$nextTick(() => {
      if (window.socialShare) {
        window.socialShare('.social-share', {
          wechatQrcodeTitle: '微信扫一扫：分享',
          wechatQrcodeHelper: '<p>微信里点"发现"，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
        })
      }
    })
  },
  watch: {
    '$route.query'() {
      this.params.id = this.$route.query.id || this.$route.query.contentId || 40
      this.getData()
    }
  },
  methods: {
    getData() {
      const self = this
      this.$axios({
        url: '/realNet/video/getVideoInfos',
        params: {
          id: this.params.id,
          containVideoFile: true,
          token: getToken() || '123456789'
        },
        headers: { token: getToken() || '123456789' },
        method: 'get'
      }).then(res => {
        const item = res.data.result && res.data.result.content ? res.data.result.content[0] : null
        if (!item) return

        if (item.provider === 1) {
          return self.$router.replace({ name: 'YouKuPlayPage', query: { contentId: item.id } })
        }
        if (item.isRmhdDownload) {
          return self.$router.replace({ name: 'DownloadDetailPage', query: { contentId: item.id } })
        }

        if (item.categoryValue && item.categoryValue.indexOf('电影') < 0) {
          self.dramasObj.disableDramas = false
        }

        const r = sessionStorage.getItem('vidSrcId' + self.params.id)
        self.dramasObj.nowEpisode = r ? parseInt(r) : 1
        self.dramasObj.episode = item.files ? item.files.length : 0
        self.dramasObj.episodeList = item.files || []

        self.videoObj.title = item.videoName
        self.videoObj.videoImg = item.horizontalImage
        self.videoObj.viewCounts = item.playAmount
        self.videoObj.chargeType = item.chargeType
        self.videoObj.permission = item.permission
        self.videoObj.description = item.description
        self.videoObj.id = self.params.id

        self.videoFiles = (item.files || []).map(f => {
          if (f.fileHls) {
            return f.fileHls
          }
          if (f.fileMp4) {
            return f.fileMp4 + '?token=' + (getToken() || '123456789')
          }
          return ''
        })

        self.mediaInfo = {
          name: item.videoName,
          videoInfo: { id: self.params.id },
          categoryId: item.categoryId,
          videoType: item.videoType,
          videoLocality: item.videoLocality
        }

        self.vidSrc = self.videoFiles[self.dramasObj.nowEpisode - 1] || null
        if (self.vidSrc) {
          sessionStorage.setItem('vidSrcId' + self.params.id, self.dramasObj.nowEpisode)
        }

        self.getSeniorityList()
        if (getUser()) {
          self.insertPlayAmount()
        }

        document.documentElement.scrollTop = 0
      })
    },
    getFooterData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        headers: { token: '123456789' },
        params: { title: '首页' }
      }).then(res => {
        if (res.data.result) {
          const dataMap = res.data.result.dataMap || res.data.result
          this.bottomBanner = dataMap.bottomBanner ? dataMap.bottomBanner[0] : null
        }
      })
    },
    getSeniorityList() {
      if (!this.mediaInfo) return
      this.$axios({
        url: '/realNet/video/getVideoInfos',
        params: {
          categoryId: this.mediaInfo.categoryId,
          videoType: this.mediaInfo.videoType,
          videoLocality: this.mediaInfo.videoLocality,
          pageSize: 12,
          orderByField: 'score',
          orderByType: 'DESC'
        },
        headers: { token: '123456789' },
        method: 'get'
      }).then(res => {
        const content = res.data.result ? res.data.result.content : []
        this.seniorityInfo.list = (content || []).map(item => ({
          id: item.id,
          src: item.horizontalImage,
          name: item.videoName || '',
          description: item.description
        }))
      })
    },
    episodeClick(num) {
      this.dramasObj.nowEpisode = num
      if (num - 1 < this.videoFiles.length) {
        this.vidSrc = this.videoFiles[num - 1]
        if (this.vidSrc) {
          sessionStorage.setItem('vidSrcId' + this.params.id, num)
        }
      }
    },
    collectClick() {
      if (!getUser()) {
        this.$message({ message: '你还未登录，请先登录', type: 'warning', duration: 1000 })
        return
      }
      this.$axios({
        url: '/realNet/history/insert',
        method: 'post',
        data: {
          categoryId: this.mediaInfo ? this.mediaInfo.categoryId : '',
          name: this.videoObj.title,
          videoFileId: this.dramasObj.episodeList[this.dramasObj.nowEpisode - 1]
            ? this.dramasObj.episodeList[this.dramasObj.nowEpisode - 1].id : '',
          type: 2
        },
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({ message: '收藏成功', type: 'success' })
        }
      })
    },
    insertPlayAmount() {
      this.$axios({
        url: '/realNet/video/updatePlayAmount',
        method: 'post',
        data: { id: this.params.id },
        headers: { token: getToken() }
      })
    },
    goDetail(item) {
      this.$router.push({ path: '/tvplay-page', query: { id: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.play {
  overflow: hidden;
}

.play .main {
  width: 100%;
  background: #191a20;
  overflow: hidden;
}

.play .main .subject {
  display: flex;
  margin: 10px 13.8% 7px 13%;
  width: 100%;
}

.play .main .subject .subject_left {
  width: 53%;
  height: 576px;
  position: relative;

  .player {
    width: 100%;
    height: 100%;
  }
}

.play .main .subject .subject_right {
  width: 19%;
  height: 576px;
  background: rgba(20, 20, 20, 0.5);
  border-radius: 5px;
  margin-left: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .title {
    font-family: PingFang;
    font-weight: 400;
    font-size: 20px;
    color: #fff;
    margin: 23px 19px 16px;
  }

  .notice {
    font-family: PingFang;
    font-weight: 400;
    font-size: 14px;
    color: #999;
    margin: 0 17px;
    text-align: justify;
  }

  .but {
    height: 76px;
    background: hsla(0, 0%, 100%, 0.09);
    border-radius: 5px;
    margin: 22px 20px 26px 16px;
    font-family: PingFang;
    font-weight: 400;
    font-size: 12px;
    color: #999;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    position: relative;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      > img {
        width: 32px;
        height: 32px;
      }

      span {
        margin-top: 8px;
      }

      &:nth-child(2) {
        width: 1px;
        height: 45px;
        background-color: #535353;
      }
    }
  }

  .social-share {
    margin: 0 16px;
    padding: 10px 16px;
    background: #fff;
    border-radius: 5px;
  }

  .collection {
    font-family: PingFang;
    font-weight: 400;
    font-size: 20px;
    color: #fff;
    margin: 0 19px;
  }

  .collectionNum {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 16px 0;

    div {
      padding: 0 10px;
      height: 28px;
      background: hsla(0, 0%, 100%, 0.09);
      border-radius: 14px;
      font-family: PingFang;
      font-weight: 400;
      font-size: 14px;
      color: #999;
      text-align: center;
      line-height: 28px;
      box-sizing: border-box;
      margin-right: 10px;
      margin-bottom: 10px;
      cursor: pointer;
    }

    .select {
      color: #674bc6;
    }
  }

  .grid {
    display: flex;
    flex-wrap: wrap;
    margin-left: 6px;

    li {
      width: 45px;
      height: 45px;
      background: hsla(0, 0%, 100%, 0.09);
      border-radius: 5px;
      font-family: PingFang;
      font-weight: 400;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 45px;
      margin-left: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      list-style: none;
    }

    .select {
      color: #674bc6;
    }
  }
}

.play .main .details {
  background: rgba(20, 20, 20, 0.5);
  border-radius: 5px;
  margin: 0 263px 38px 252px;

  .title {
    margin: 17px 12px 19px;
    padding: 0;
    border: 0;
    display: flex;
    align-items: baseline;

    span:first-child {
      font-family: PingFang;
      font-weight: 700;
      font-size: 30px;
      color: #fff;
    }

    span:nth-child(2) {
      font-family: PingFang;
      font-weight: 400;
      font-size: 14px;
      color: #fff;
      margin-left: 22px;
    }
  }

  .brief {
    margin: 0 12px;
    font-family: PingFang;
    font-weight: 400;
    font-size: 14px;
    color: #999;

    span {
      margin-right: 10px;
    }
  }

  .cont {
    margin: 16px 17px 6px;
    font-family: PingFang;
    font-weight: 400;
    font-size: 14px;
    color: #999;
    height: 69px;
    line-height: 22px;
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.recommend {
  margin: 66px 202px 104px 284px;

  .title {
    font-family: PingFang;
    font-weight: 700;
    font-size: 30px;
    color: #000;
    margin-bottom: 15px;
  }

  .main_list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;

    li {
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;

      img {
        width: 210px;
        height: 118px;
        border-radius: 5px;
      }

      .name {
        font-family: PingFang;
        font-weight: 400;
        font-size: 16px;
        color: #000;
        margin-top: 10px;
        width: 210px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.advertisement {
  margin: 0 202px 50px 284px;

  img {
    width: 100%;
    border-radius: 5px;
  }
}
</style>
